export let ConvertGoalType;
(function (ConvertGoalType) {
  ConvertGoalType["SignupInitiated"] = "SignupInitiated";
  ConvertGoalType["SignupCompleted"] = "SignupCompleted";
  ConvertGoalType["ExistingUser"] = "ExistingUser";
})(ConvertGoalType || (ConvertGoalType = {}));